import useJwt from "@/libs/auth/jwt/useJwt";

const axios = useJwt.axiosIns;
export const getMenus = (params) => axios.get("/api/menu", params);
export const getMenusTree = (params) => axios.get("/api/menu-tree", params);
export const getMenu = (id) => axios.get(`/api/menu/${id}`);
export const updateMenu = (data) => axios.put(`/api/menu/${data.menu_id}`, data);
export const addMenu = (data) => axios.post(`/api/menu`, data);
export const deleteMenu = (id) => axios.delete(`/api/menu/${id}`);
